@if (initialized && contractsRuntime) {
  <div class="flex flex-wrap justify-content-between w-full md:px-1 px-2 align-items-center">
    <div class="flex flex-wrap md:align-items-start md:gap-3 md:justify-content-start justify-content-between"
         [ngClass]="showGroups ? 'md:w-auto w-full' : ''">
      @for (group of contractsRuntime.groups; track group.name) {

        <div [ngClass]="showGroups ? '' : 'mbl-groups'"
             class="display-groups hover:primary-200 border-1 border-200 border-round-md cursor-pointer pt-2 pb-3 px-3 hover:bg-blue-50 hover:border-blue-200 group-box"
             (click)="showContractsForCategory(group)">

            <span class="font-medium text-500 uppercase line-height-4 flex justify-content-between align-items-center">
            <span class="text-color-secondary">{{ group.name }} </span>
              @if (group.activeContracts > 0) {
                <p-badge class="" styleClass="bg-bluegray-400" [value]="group.activeContracts+''"></p-badge>
              }
          </span>
          @if(!busy){
            <div class="text-color mt-2 font-semibold">{{ group.activeContractCost?.formattedAmount }}</div>
          }
          @else{
          <p-progressSpinner styleClass=" h-2rem"></p-progressSpinner>
          }
        </div>

      }


      <div class="surface-50 border-round px-3" [ngClass]="showGroups ? 'group-box mb-0 lg:w-auto w-full' : 'group-box'">

          <span class="font-light text-500 uppercase line-height-4">Gesamt</span>
          <div class="flex md:flex-column" [ngClass]="showGroups ? 'justify-content-between' : 'flex-column'">
            @if(!busy){
            <div class="text-700 font-bold text-lg"
                 style="margin-top: .1rem">{{ contractsRuntime.totalCost?.formattedAmount }}
            </div>
            <div class="text-500 mt-1 mb-2 font-italic">{{ contractFrequency | contractFrequency:'jährlich' }}</div>
            }
            @else{
              <p-progressSpinner styleClass=" h-2rem"></p-progressSpinner>
            }
          </div>
      </div>

    </div>
    <!--    <div class="lg:mt-2 mt-3 lg:text-start text-center display-groups" [ngClass]="showGroups ? '' : 'mbl-groups'">-->
    <!--      <p-selectButton (onChange)="handleFrequency()" [options]="contractFrequencyOptions"-->
    <!--                      [(ngModel)]="contractFrequency" optionLabel="label" optionValue="value"></p-selectButton>-->
    <!--    </div>-->
  </div>
  <div class="md:hidden flex gap-1 align-items-center text-primary text-sm p-2 mt-2 mx-2"
       pRipple
       (click)="showContractDetail()">
    <span>{{ showGroups ? 'Ausklappen' : 'Einklappen' }}</span>
    <i class="pi pi-chevron-down text-xs"></i>
  </div>

}

